import TomSelect from "tom-select";
import { config, renderBasic } from "../TomSelect/config";
import { getCitiesByName, getCitiesById } from "../helpers/CityApi";

export function initCitySelects() {
	const selects = document.querySelectorAll('select[data-select-entity="city"]');

	selects.forEach((select) => {
		const tomSelect = new TomSelect(select, {
			...config, ...{
				render: renderBasic,
				load: function (query, callback) {
					const self = this;

					if (self.loading > 1) {
						callback();
						return;
					}

					getCitiesByName(encodeURIComponent(query))
						.then(res => res.data)
						.then(json => {
							callback(json);
						}).catch(() => callback());
				}
			}
		});

		const defaultOptions = select.dataset.value ? JSON.parse(select.dataset.value) : [];

		if (defaultOptions.length) {
			getCitiesById(defaultOptions).then(res => {
				res.data.forEach((city, index) => {
					tomSelect.addOption(city);
					tomSelect.addItem(index);
				});

				tomSelect.setValue(defaultOptions);
			});
		}
	});
}
